import React, { useCallback, useEffect, useState } from "react";
import api from "../../util/panelApi";
import { PageHead, Chip } from "./kit";

/// 5 Kas: Supheli hareket uyarilari + magaza iadeleri
const TUR = {
  hediye: ["Büyük hediye", "live"],
  harcama: ["Yoğun harcama", "wait"],
  engelKacagi: ["Engel kaçağı", "bad"],
  cokHesap: ["Aynı telefon", "info"],
  elmas: ["Ani elmas", "wait"],
  iade: ["Mağaza iadesi", "bad"],
};
const zaman = (d) => (d ? new Date(d).toLocaleString("tr-TR", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" }) : "—");

const UyariListe = () => {
  const [hepsi, setHepsi] = useState(false);
  const [tur, setTur] = useState("");
  const [d, setD] = useState(null);
  const load = useCallback(async () => {
    const r = await api.uyarilar(hepsi, tur);
    setD(r?.status ? r : { rows: [], sayi: [] });
  }, [hepsi, tur]);
  useEffect(() => {
    load();
  }, [load]);
  const oku = async (ids, tum) => {
    await api.uyariOkundu(tum ? { hepsi: true } : { ids });
    load();
  };
  if (!d) return <div className="badu-empty">Yükleniyor…</div>;
  const say = (k) => d.sayi?.find((x) => x._id === k)?.n || 0;
  return (
    <div className="card">
      <div className="card-body">
        <div className="d-flex align-items-center" style={{ gap: 6, flexWrap: "wrap", marginBottom: 10 }}>
          <button className={`btn btn-sm ${!tur ? "btn-primary" : "btn-light"}`} onClick={() => setTur("")}>Tümü</button>
          {Object.entries(TUR).map(([k, [ad]]) => (
            <button key={k} className={`btn btn-sm ${tur === k ? "btn-primary" : "btn-light"}`} onClick={() => setTur(k)}>
              {ad} {say(k) ? <b>({say(k)})</b> : null}
            </button>
          ))}
          <label style={{ marginLeft: "auto", display: "flex", gap: 6, alignItems: "center", margin: 0 }}>
            <input type="checkbox" checked={hepsi} onChange={(e) => setHepsi(e.target.checked)} /> Okunanları da göster
          </label>
          <button className="btn btn-sm btn-outline-secondary" onClick={() => oku([], true)}>Hepsini okundu yap</button>
        </div>
        <div className="table-responsive">
          <table className="table">
            <thead><tr><th>Zaman</th><th>Tür</th><th>Uyarı</th><th></th></tr></thead>
            <tbody>
              {d.rows.map((r) => (
                <tr key={r._id} style={{ opacity: r.okundu ? 0.55 : 1 }}>
                  <td style={{ whiteSpace: "nowrap" }}>{zaman(r.at)}</td>
                  <td><Chip kind={(TUR[r.tur] || [])[1] || "info"}>{(TUR[r.tur] || [r.tur])[0]}</Chip></td>
                  <td>{r.metin}</td>
                  <td>{!r.okundu && <button className="btn btn-sm btn-light" onClick={() => oku([r._id])}>Okundu</button>}</td>
                </tr>
              ))}
              {!d.rows.length && <tr><td colSpan={4}><div className="badu-empty">Uyarı yok.</div></td></tr>}
            </tbody>
          </table>
        </div>
        <div style={{ fontSize: 12, color: "#6B7280" }}>
          Eşikler: tek hediye ≥ {(d.esik?.buyukHediye || 0).toLocaleString("tr-TR")} coin · 1 saatte harcama ≥ {(d.esik?.saatlikHarcama || 0).toLocaleString("tr-TR")} coin · 24 saatte elmas ≥ {(d.esik?.gunlukElmas || 0).toLocaleString("tr-TR")}. Tarama 10 dakikada bir. Test hesapları (1000, 1001, 2000, 8000) sayılmaz.
        </div>
      </div>
    </div>
  );
};

const Iadeler = () => {
  const [d, setD] = useState(null);
  const [msg, setMsg] = useState("");
  const load = useCallback(async () => {
    const r = await api.iadeler();
    setD(r?.status ? r : { rows: [] });
  }, []);
  useEffect(() => {
    load();
  }, [load]);
  const tara = async () => {
    setMsg("Taranıyor…");
    const r = await api.iadeTara();
    setMsg(r?.message || "Yapılamadı");
    load();
  };
  if (!d) return <div className="badu-empty">Yükleniyor…</div>;
  return (
    <div className="card">
      <div className="card-body">
        <div className="d-flex align-items-center" style={{ gap: 10, flexWrap: "wrap", marginBottom: 10 }}>
          <button className="btn btn-primary btn-sm" onClick={tara}>Google iadelerini şimdi tara</button>
          {msg && <Chip kind="info">{msg}</Chip>}
          <span style={{ marginLeft: "auto", fontSize: 12, color: "#6B7280" }}>
            Son Google taraması: {d.googleSon ? `${zaman(d.googleSon.at)} · ${d.googleSon.hata || `${d.googleSon.n || 0} kayıt, ${d.googleSon.yeni || 0} yeni`}` : "henüz yok"}
          </span>
        </div>
        <div className="table-responsive">
          <table className="table">
            <thead><tr><th>Zaman</th><th>Mağaza</th><th>Kullanıcı</th><th>Coin</th><th>Düşülen</th><th>Borç</th><th>Tutar</th></tr></thead>
            <tbody>
              {d.rows.map((r) => (
                <tr key={r._id}>
                  <td>{zaman(r.at)}</td>
                  <td>{r.platform === "ios" ? "App Store" : "Google Play"}</td>
                  <td>{r.eslesmedi ? <span style={{ color: "#9CA3AF" }}>Bizde kaydı yok ({r.transactionId})</span> : `${r.name || ""} (${r.uniqueID || ""})`}</td>
                  <td>{(r.coin || 0).toLocaleString("tr-TR")}</td>
                  <td>{(r.dusulen || 0).toLocaleString("tr-TR")}</td>
                  <td>{r.borc ? <Chip kind="bad">{r.borc.toLocaleString("tr-TR")}</Chip> : "—"}</td>
                  <td>${(r.usd || 0).toFixed(2)}</td>
                </tr>
              ))}
              {!d.rows.length && <tr><td colSpan={7}><div className="badu-empty">İade yok.</div></td></tr>}
            </tbody>
          </table>
        </div>
        <div style={{ fontSize: 12, color: "#6B7280" }}>
          Google iadeleri 6 saatte bir otomatik taranır. Apple iadeleri için App Store Connect → Uygulama → App Information → App Store Server Notifications → Production URL: <b>https://api.badulive.online/adminPanel/apple/notify</b> (Version 2). İade gelince coin hesaptan düşülür; yetmezse kalanı borç olarak işaretlenir.
        </div>
      </div>
    </div>
  );
};

const Uyarilar = () => {
  const [tab, setTab] = useState("uyari");
  return (
    <div className="mainDashboard">
      <PageHead
        title="Uyarılar"
        sub="Şüpheli hareketler ve mağaza iadeleri"
        right={
          <div className="btn-group">
            <button className={`btn btn-sm ${tab === "uyari" ? "btn-primary" : "btn-light"}`} onClick={() => setTab("uyari")}>Uyarılar</button>
            <button className={`btn btn-sm ${tab === "iade" ? "btn-primary" : "btn-light"}`} onClick={() => setTab("iade")}>Mağaza iadeleri</button>
          </div>
        }
      />
      {tab === "uyari" ? <UyariListe /> : <Iadeler />}
    </div>
  );
};

export default Uyarilar;
